<script lang="ts">
    import AddIcon from "../icons/AddIcon.svelte";
    import Modal from "../modal/Modal.svelte";
    import ajax from '../../ajax/ajax';
    export let path: string;
    export let projectId: string;
    export let close: () => void;

    let fileUpload;

    function upload() {
      const fileList: FileList = fileUpload.files;
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList.item(i);
        const uri = `/projects/${projectId}/tree`;
        ajax.putFile(uri, file, {path: path}, () => {
          window.location.reload();
        });
      }
    }
</script>

<div class="UploadModal">
    <Modal title="Upload" icon={AddIcon} closeCallback={close}>
        {path}
        <form
              id='uploadForm'
            >
            Choose File
            <input type="file" name="sampleFile" bind:this={fileUpload} />
            <input type='submit' value='Upload!' on:click|preventDefault={upload} />
        </form>
    </Modal>
</div>
